import { useSuspenseQuery } from '@apollo/client/react';

import { TaskStatusEnum } from 'src/graphql/schema';
import { CompanyDocument } from 'src/graphql/actions/company/company.query';
import { AwaitingLegacyReposCountDocument } from 'src/graphql/actions/legacyRepos/awaitingLegacyReposCount.query';
import { ProfileDocument } from 'src/graphql/actions/profile/profile.query';
import { TasksDocument } from 'src/graphql/actions/tasks/tasks.query';
import { AppSidebar, SidebarSkeleton } from 'src/components/Layout/AppSidebar';
import { withSuspense } from 'src/hoc/withSuspense';
import { apolloCache as cache } from 'src/graphql';

const SidebarContainer = () => {
  const { data: legacyReposCount } = useSuspenseQuery(AwaitingLegacyReposCountDocument);
  const { data: profileData } = useSuspenseQuery(ProfileDocument);
  const { data: tasksData } = useSuspenseQuery(TasksDocument, {
    variables: { status: TaskStatusEnum.Unread, perPage: 0 },
  });

  const dataCompany = cache.readQuery({ query: CompanyDocument });
  const nodesCount = legacyReposCount?.legacyRepos.count ?? 0;
  const tasksCount = tasksData?.tasks.nodesCount ?? 0;

  return (
    <AppSidebar
      migrationsCount={nodesCount}
      tasksCount={tasksCount}
      user={{
        name: profileData.profile.name ?? '',
        email: profileData.profile.email ?? '',
      }}
      withIntegrations={dataCompany?.company.policy.readIntegrations}
      withAuditLogs={dataCompany?.company.policy.readAuditLog}
    />
  );
};

export default withSuspense(SidebarContainer, SidebarSkeleton);
